<template>
  <div class="evaCard">
    <img
      class="back"
      @click="goHome"
      v-lazy="require('./../../../assets/img/back2.png')"
    />
    <van-tabs v-model="activeName" @click="getroadList">
      <van-tab :title="'待评价(' + total + ')'" name="no">
        <NoPic style="margin-top: 50%" v-if="!evalistLen['no']"></NoPic>
        <van-pull-refresh v-model="isDownLoading" @refresh="onDownRefresh">
          <van-list
            v-model="isUpLoading"
            :finished="upFinished"
            :immediate-check="false"
            :offset="10"
            finished-text="我是有底线的"
            @load="onLoadList"
          >
            <evaCard
              v-for="(item, index) in evalist['no']"
              :key="index"
              :item="item"
              :flag="0"
            ></evaCard>
          </van-list>
        </van-pull-refresh>
      </van-tab>
      <van-tab :title="'已评价(' + total2 + ')'" name="yes">
        <NoPic style="margin-top: 50%" v-if="!evalistLen['yes']"></NoPic>
        <van-pull-refresh v-model="isDownLoading" @refresh="onDownRefresh">
          <van-list
            v-model="isUpLoading"
            :finished="upFinished"
            :immediate-check="false"
            :offset="10"
            finished-text="我是有底线的"
            @load="onLoadList"
          >
            <evaCard
              v-for="(item, index) in evalist['yes']"
              :key="index"
              :item="item"
              :flag="1"
            ></evaCard>
          </van-list>
        </van-pull-refresh>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import evaCard from "@/components/evaCard";
import { getMyTest } from "@/http/api";
import NoPic from "@/components/NoPic";
import { mapGetters } from "vuex";
export default {
  name: "evaluation",
  data() {
    return {
      activeName: "no",
      evalist: {
        no: [],
        yes: [],
      },
      evalistLen: {
        no: 0,
        yes: 0,
      },
      // 已评价

      // 分页
      total: 0,
      pageSize: 10, // 每页条数
      pageIndex: 1, // 页码
      // 记录已评价
      total2: 0,
      pageSize2: 10, // 每页条数
      pageIndex2: 1,
      // 记录变化值
      flag: 0,
      flag2: 0,
      isDownLoading: false, // 下拉刷新
      isUpLoading: false, // 上拉加载
      upFinished: false, // 上拉加载完毕
      offset: 100, // 滚动条与底部距离小于 offset 时触发load事件
    };
  },
  methods: {},
  computed: {
    ...mapGetters(["user_id"]),
  },
  created() {
    let params;
    if (this.activeName === "no") {
      params = {
        page: this.pageIndex,
        page_size: this.pageSize,
        is_commented: this.activeName,
      };
    }
    if (this.activeName === "yes") {
      params = {
        page: this.pageIndex2,
        page_size: this.pageSize2,
        is_commented: this.activeName,
      };
    }
    this.getList(params);
    getMyTest({ ...params, is_commented: "yes" }).then((res) => {
      this.total2 = res.data.count || 0;
    });
    // this.getroadList()
    // console.log(this.user, this.user_id)
  },
  methods: {
    goHome() {
      this.$router.push("/my/center");
    },
    // 获取列表
    getList(params) {
      //  let params = {
      //   page: this.pageIndex,
      //   page_size: this.pageSize,
      //   is_commented: this.activeName,
      // }
      if (params.is_commented === "no") {
        params.is_finished = "finished";
      }
      getMyTest(params)
        .then((res) => {
          // console.log('获取测评',res);
          if (this.activeName === "no") {
            this.total = res.data.count || 0;
          } else if (this.activeName === "yes") {
            this.total2 = res.data.count || 0;
          }

          if (res.data.hasOwnProperty("objects")) {
            this.evalist[this.activeName] = this.evalist[
              this.activeName
            ].concat(res.data.objects);
            this.evalistLen[this.activeName] =
              this.evalist[this.activeName].length;
            // console.log(
            //   "获取测评",
            //   params,
            //   "this.evalist",
            //   this.evalist,
            //   "this.evalistLen",
            //   this.evalistLen
            // );
          }
        })
        .finally(() => {
          this.isDownLoading = false;
          this.isUpLoading = false;
        });
    },
    getroadList() {
      //   this.evalist[this.activeName]=[]
      //   console.log('this.activeName',this.activeName)
      console.log("this.total", this.total, this.total2);
      let params;
      //   if(this.activeName==='no'){
      //     params = {
      //     page: this.pageIndex,
      //     page_size: this.pageSize,
      //     is_commented: this.activeName,
      //   }
      //   if( this.evalist[this.activeName].length>this.total) return
      // }
      if (this.activeName === "yes") {
        if (this.flag2 === 0) {
          params = {
            page: this.pageIndex2,
            page_size: this.pageSize2,
            is_commented: this.activeName,
          };
          this.flag2 = 1;
          console.log("22", this.evalist[this.activeName].length);
          if (
            this.flag2 === 0 &&
            this.evalist[this.activeName].length > this.total2
          )
            return;
          this.getList(params);
        }
      }
    },
    // 下拉刷新
    onDownRefresh() {
      this.evalist[this.activeName] = [];
      this.pageIndex = 1;
      this.pageIndex2 = 1;
      this.upFinished = false; // 不写这句会导致你上拉到底过后在下拉刷新将不能触发下拉加载事件
      // this.getroadList() // 加载数据
      let params;
      if (this.activeName === "no") {
        params = {
          page: this.pageIndex,
          page_size: this.pageSize,
          is_commented: this.activeName,
        };
      }
      if (this.activeName === "yes") {
        params = {
          page: this.pageIndex2,
          page_size: this.pageSize2,
          is_commented: this.activeName,
        };
      }
      console.log("params", params);
      this.getList(params);
    },
    // 上拉加载请求方法
    onLoadList() {
      if (this.activeName === "no") {
        if (this.total > this.pageIndex * this.pageSize) {
          this.pageIndex++;
          // this.getroadList()
          let params = {
            page: this.pageIndex,
            page_size: this.pageSize,
            is_commented: this.activeName,
          };
          this.getList(params);
        } else {
          this.upFinished = true;
        }
      } else if (this.activeName === "yes") {
        if (this.total2 > this.pageIndex2 * this.pageSize2) {
          this.pageIndex2++;
          // this.getroadList()
          let params = {
            page: this.pageIndex2,
            page_size: this.pageSize2,
            is_commented: this.activeName,
          };

          this.getList(params);
        } else {
          this.upFinished = true;
        }
      }
    },
  },
  components: {
    evaCard,
    NoPic,
  },
};
</script>

<style lang="less">
.back {
  width: 22px;
  height: 23px;
  background-repeat: no-repeat;
  background-size: contain;
  position: absolute;
  left: 5px;
  top: 5px;
  z-index: 100;
}
.evaCard {
  .van-tab {
    background-color: #eceff5;
  }
  .van-tabs__line {
    background-color: #42686e;
    /*width: 100%;*/
  }
}
</style>